import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { PreferencesProvider } from "@/contexts/PreferencesContext";
import { lazy, Suspense } from "react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import LandingPage from "./pages/LandingPage";
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Refund = lazy(() => import("./pages/Refund"));
const Faq = lazy(() => import("./pages/Faq"));
const Features = lazy(() => import("./pages/Features"));
const SharedDiary = lazy(() => import("./pages/SharedDiary"));
const SharedNote = lazy(() => import("./pages/SharedNote"));
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));

// Lazy load auth-protected app with a separate bundle that includes auth and database
const ProtectedApp = lazy(() => import("./ProtectedApp"));

// Loading fallback
const LoadingFallback = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-pulse text-primary">Loading...</div>
  </div>
);

const App = () => (
  <>
    <ThemeProvider>
      <PreferencesProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter future={{
            v7_startTransition: true,
          }}>
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                {/* Main route - Always render the landing page without auth/db providers */}
                <Route path="/" element={<LandingPage />} />

                {/* Static content pages */}
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/refund" element={<Refund />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/features" element={<Features />} />

                {/* Shared diary view - public route */}
                <Route path="/share/diary/:encodedContent" element={<SharedDiary />} />

                {/* Shared note view - public route */}
                <Route path="/s/:id" element={<SharedNote />} />

                {/* Blog routes — completely separate from the app bundle */}
                <Route path="/blog" element={<BlogIndex />} />
                <Route path="/blog/:slug" element={<BlogArticle />} />

                {/* Legacy intro page - redirect to landing */}
                <Route path="/intro" element={<Navigate to="/" replace />} />

                {/* All protected routes - loaded in a separate bundle.
                    This also owns the 404 path: ProtectedApp's own catch-all
                    redirects unknown paths, so a sibling `*` route here would
                    be unreachable. */}
                <Route path="/*" element={<ProtectedApp />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </PreferencesProvider>
    </ThemeProvider>
    <SpeedInsights />
  </>
);

export default App;
